import { throttle, PreviewImages } from "@/utils/tools";
import { domPixelRatio } from 'md-base-tools/env';
import { getUnlockGoalEditRecord } from '@/api/index';
import Error from "@@/common/Error.vue";
export default {
  data() {
    return {
      showError: false,
      showMessage: '',
      giveaway_type: 0,
      // 1:每个用户ID获得1次 2:每个订单获得1次 3:每份回报档获得1次
      edit_count: 0,
      edit_time: '',
      edit_list: [],
      update_id: '',
      isLoading: false,
      refreshing: false,
      loading: false,
      finished: false
    };
  },
  computed: {
    ratio() {
      return parseInt(domPixelRatio()) || 1;
    },
    giveawayTypeText() {
      const typeMap = {
        1: '每个用户ID获得1次',
        2: '每个订单获得1次',
        3: '每份回报档获得1次'
      };
      return typeMap[this.giveaway_type] || '';
    }
  },
  components: {
    Error
  },
  async created() {
    window.userHeader.titleText("编辑记录");
    document.title = "编辑记录";
    const update_id = this.$route.params.id ? this.$route.params.id.replace('.html', '') : '';
    this.update_id = update_id;
    if (!this.update_id) {
      this.showError = true;
      this.showMessage = '未找到更新ID';
    }
  },
  methods: {
    formatAmount(amount) {
      if (amount === null || amount === undefined) {
        return '';
      }
      let parts = amount.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    // 获取列表
    getList: throttle(async function () {
      if (this.isLoading) return;
      const res = await getUnlockGoalEditRecord({
        update_id: this.update_id
      });
      if (res.status == 0) {
        this.giveaway_type = res.data.giveaway_type;
        this.edit_count = res.data.edit_count;
        this.edit_time = res.data.edit_date;
        this.edit_list = res.data.list;
        this.finished = !res.data.is_next;
      } else {
        this.showError = true;
        this.showMessage = res.message;
      }
      this.page += 1;
      this.isLoading = false;
      this.loading = false;
      this.refreshing = false;
    }, 100),
    onRefresh() {
      this.finished = false;
      this.getList();
    },
    showBigImg(index, prizes) {
      let arr = [];
      prizes.forEach(item => {
        arr.push(item.img);
      });
      console.log('arr', arr);
      PreviewImages(index, arr);
    }
  }
};